import AbstractComponent from './abstract-component';

/**
 * Évite le conflit Lenis ↔ iframe Google Maps au survol.
 */
export default class GoogleMap extends AbstractComponent {
    constructor(el) {
        super(el);
        this.isHovered = false;
        this.DOM = {
            map: el.querySelector('.c-google-map__map'),
        };
        this.onEnter = this.onEnter.bind(this);
        this.onLeave = this.onLeave.bind(this);
        this.initEvents();
    }

    initEvents() {
        const target = this.DOM.map || this.$el;
        target.addEventListener('mouseenter', this.onEnter);
        target.addEventListener('mouseleave', this.onLeave);
    }

    onEnter() {
        this.isHovered = true;
        if (this.app?.$scroll) {
            this.app.$scroll.disable();
        }
    }

    onLeave() {
        this.isHovered = false;
        if (this.app?.$scroll) {
            this.app.$scroll.enable();
        }
    }

    destroy() {
        const target = this.DOM.map || this.$el;
        target.removeEventListener('mouseenter', this.onEnter);
        target.removeEventListener('mouseleave', this.onLeave);
        if (this.isHovered && this.app?.$scroll) {
            this.app.$scroll.enable();
        }
    }
}
